<template>
  <div :class="[bem()]">
    <div class="product-info border1px">
      <div :class="['border1px', 'product-item']" @click="() => handleClick()">
        <img
          class="product-img"
          v-lazy="
            isBundled
              ? (orderCommoditySuite && orderCommoditySuite.suitePic) || commodity.commodityImgUrl
              : commodity.commodityImgUrl
          "
        />
        <div class="product-detail">
          <div class="title">
            <div class="title-left">
              <!--eslint-disable-next-line-->
              <span class="commodity-name" :class="commodity.actTagCode || purchaseChannel ? 'lc-3' : 'lc-2'">
                <img
                  class="act-tag"
                  v-if="commodity.actTagCode"
                  v-lazy="require(`@/assets/img/order/${commodity.actTagCode}.png`)"
                  alt=""
                />
                <img class="act-tag" v-lazy="require(`@/assets/img/order/live.png`)" v-else-if="purchaseChannel == 1" />
                <span>{{ title }}</span>
              </span>
            </div>
            <div class="number" v-if="!(type === 'apply-list' && num >= 1 && refundType == 2 && isNewOrder)">
              x{{ commodity.quantity }}
            </div>
          </div>
          <!--<div class="color" v-if="!isBundled && commodity.color">颜色：{{ commodity.color }}</div>-->
          <div class="price-and-score">
            <div class="price-list">
              <div :class="price">
                &yen;{{
                  unBalancePayment && orderBase.tailReduceAmt
                    ? salePrice - orderBase.tailReduceAmt >= 0
                      ? salePrice - orderBase.tailReduceAmt
                      : 0
                    : salePrice | formatMoney
                }}
              </div>
              <v-price-cut-icon
                v-if="type === 'detail' && unBalancePayment && orderBase.tailReduceAmt"
                :title="`已降价￥${orderBase.tailReduceAmt}`"
              ></v-price-cut-icon>
              <!--如果是新的订单或结算信息，则不展示划线价-->
              <div class="price-del" v-if="!isNew && salePrice < delPrice">&yen;{{ delPrice | formatMoney }}</div>
            </div>
            <!-- 商品行数量选择器 -->
            <div
              class="num-stepper"
              v-if="type === 'apply-list' && num > 1 && refundType == 2 && isNewOrder"
              @click.stop
            >
              <v-stepper v-model="applyNum" disable-input min="1" :max="commodity.quantity" @change="onChange" />
            </div>
            <!-- <div class="score" v-if="type === 'detail'">
              赠送积分：
              <span class="value">{{ config.vScore / commodity.quantity }}</span>
            </div> -->
            <slot class="product-extra" name="product-extra"></slot>
          </div>
        </div>
      </div>
      <!-- 分开 -->
      <template v-if="!isBundled && !onlyShowProduct">
        <template>
          <div class="gift" v-if="giftList && giftList.length > 0">
            <Gift
              :gList="gList"
              :type="type"
              :showTypeIcon="true"
              :customParams="customParams"
              :giftShowOpt="giftShowOpt"
              @optionGiftChange="handleGiftSelect"
              :tips="giftTips"
            ></Gift>
          </div>
          <div class="service" v-if="config.serviceList && config.serviceList.length > 0">
            <span class="label border1px">服务</span>
            <div class="value">
              <div class="item" v-for="(item, key) in config.serviceList" :key="key">
                <div class="name">{{ item.commodityName }}</div>
                <div :class="price">&yen;{{ item.salePrice || item.marketPrice }}</div>
              </div>
            </div>
          </div>
        </template>
        <div class="laser" v-if="laserInfoChange">
          <span class="label border1px">定制</span>
          <div class="value">
            <div class="value-left">
              <template v-if="config.laserInfo">
                <div class="item" v-if="config.laserInfo.picName">图片：{{ config.laserInfo.picName }}</div>
                <div class="item" v-if="config.laserInfo.firstLine">第一行：{{ config.laserInfo.firstLine }}</div>
                <div class="item" v-if="config.laserInfo.secondLine">第二行：{{ config.laserInfo.secondLine }}</div>
              </template>
              <template v-if="config.laserInfoV2 && config.laserInfoV2.laserDesList">
                <div class="item" :key="item.id" v-for="item in config.laserInfoV2.laserDesList">{{ item }}</div>
              </template>
            </div>
            <div
              class="value-right"
              @click.stop="showBigImg"
              v-track="{
                act: 'click',
                params: {
                  event_id: customParams.cfrom_click_laser,
                  cfrom: customParams.cfrom_click_laser,
                  taskType: 1
                }
              }"
            >
              <img src="@/assets/img/laser/laser-preview-icon.png" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="bundled" v-if="isBundled && !onlyShowProduct">
      <Package :product="getPackage" :customParams="customParams"></Package>
      <div class="other-box">
        <div class="gift" v-if="giftList && giftList.length > 0">
          <Gift
            :gList="gList"
            :type="type"
            :showTypeIcon="true"
            :customParams="customParams"
            :giftShowOpt="giftShowOpt"
            @optionGiftChange="handleGiftSelect"
            :tips="giftTips"
          ></Gift>
        </div>
        <div class="service" v-if="config.serviceList && config.serviceList.length > 0">
          <span class="label border1px">服务</span>
          <div class="value">
            <div class="item" v-for="(item, key) in config.serviceList" :key="key">
              <div class="name">{{ item.commodityName }}</div>
              <span :class="price">&yen;{{ item.salePrice || item.marketPrice }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="laser" v-if="laserInfoChange">
        <span class="label border1px">定制</span>
        <div class="value">
          <div class="value-left">
            <template v-if="config.laserInfo">
              <div class="item" v-if="config.laserInfo.picName">图片：{{ config.laserInfo.picName }}</div>
              <div class="item" v-if="config.laserInfo.firstLine">第一行：{{ config.laserInfo.firstLine }}</div>
              <div class="item" v-if="config.laserInfo.secondLine">第二行：{{ config.laserInfo.secondLine }}</div>
            </template>
            <template v-if="config.laserInfoV2 && config.laserInfoV2.laserDesList">
              <div class="item" :key="item.id" v-for="item in config.laserInfoV2.laserDesList">{{ item }}</div>
            </template>
          </div>
          <div
            class="value-right"
            @click.stop="showBigImg"
            v-track="{
              act: 'click',
              params: {
                event_id: customParams.cfrom_click_laser,
                cfrom: customParams.cfrom_click_laser,
                taskType: 1
              }
            }"
          >
            <img src="@/assets/img/laser/laser-preview-icon.png" />
          </div>
        </div>
      </div>
    </div>
    <v-image-preview
      v-if="laserInfoChange && laserInfoChange.previewSrc"
      :show="isShowBigImg"
      :images="[laserInfoChange.previewSrc]"
      :theKey="0"
      :onClose="hideBigImg"
      class="image-preview"
    ></v-image-preview>
    <!-- 商品行数量选择器 -->
    <div class="sole-stepper border1px" v-if="type === 'apply-list' && num === 1 && refundType == 2 && isNewOrder">
      <span>申请数量</span>
      <div class="num-stepper">
        <v-stepper v-model="applyNum" disable-input :min="stepNumChange" :max="commodity.quantity" @change="onChange" />
      </div>
    </div>
    <!-- 按钮组 -->
    <OrderAction
      v-if="type === 'detail' && config.operationButtonList && config.operationButtonList.length > 0"
      :actions="config.operationButtonList"
      :orderItemNo="commodity.orderItemNo"
      :refundNo="config.refundNo || refundNo"
      :orderNo="customParams.orderNo"
      :orderBase="orderBase"
      type="detail"
    />
  </div>
</template>

<script>
import create from '../create'
import Gift from '@/components/gift'
import Package from '@/components/package'
import app from 'utils/app'
import OrderAction from '../../views/my/order/components/order-action/index'
import { calcRefundCommodityReq } from './api'
import env from 'utils/clientEnv'
import { formatSpuName } from 'utils/common'

export default create({
  name: 'product-item',
  components: {
    Gift,
    Package,
    OrderAction
  },
  props: {
    config: Object,
    // 价保集成页，申请历史列表，只展示产品信息，不展示，套餐、服务等
    onlyShowProduct: {
      type: Boolean,
      default: false
    },
    orderItemNo: String,
    num: Number,
    isNewOrder: Boolean,
    refundType: String,
    type: String,
    orderNo: String,
    orderType: String,
    refundNo: String,
    bigImgCallback: Function,
    isShowBigImg: false,
    giftList: Array,
    orderStatus: {
      type: String
    },
    customParams: Object,
    // 是否跳转到详情页
    linkToProduct: {
      type: Boolean,
      default: true
    },
    // 是否为新的商品信息，老的订单优惠计算还沿用老的
    isNew: {
      type: Boolean,
      default: true
    },
    tempTerminal: {
      type: Number || null
    },
    grouponStatus: {
      type: Number,
      default: 0
    },
    clickEvent: {
      type: Boolean,
      default: false
    },
    orderBase: Object,
    grouponType: Number,
    giftShowOpt: [Number, String], // 结算页赠品行是否展开
    giftTips: String, // 赠品行里的信息提示
    purchaseChannel: Number,
    unBalancePayment: Boolean
  },
  data() {
    const { orderCommodity = {}, orderCommodityVO } = this.config
    const { quantity } = orderCommodity

    return {
      gList: this.giftList,
      applyNum: !isNaN(Number(quantity)) ? quantity : orderCommodityVO.quantity
    }
  },
  watch: {
    giftList: {
      deep: true,
      immediate: true,
      handler(val) {
        this.gList = val
      }
    },
    config(val) {
      this.applyNum = (val.orderCommodity && val.orderCommodity.quantity) || val.orderCommodityVO.quantity
    }
  },
  computed: {
    title() {
      if (this.isBundled) {
        const spuName = formatSpuName(this.config.orderCommodity?.commodityName )
        return spuName + (this.orderCommoditySuite && this.orderCommoditySuite.name) || '套餐商品'
      }
      return this.commodity.commodityName.trim().replace(/\s+\d*G[a-zA-Z]*\s*\+?\s*\d*[G|T][a-zA-Z]*/, s => `\n${s}`)
    },
    commodity() {
      return this.config.orderCommodity || this.config.orderCommodityVO
    },
    salePrice() {
      if (this.isNew) {
        return this.config.commodityFinalAmount
      } else {
        if (this.isBundled) {
          // 套餐
          if (this.orderCommoditySuite?.suitePrice) {
            return this.orderCommoditySuite.suitePrice
          }
          return (this.config.amount - this.config.promotionAmount) / this.commodity.quantity
        } else {
          return this.commodity.salePrice
        }
      }
    },
    isBundled() {
      return (this.config.bundledList || []).length > 0
    },
    // 套餐名称、头图
    orderCommoditySuite() {
      return this.config && this.config.orderCommoditySuite
    },
    bundledDelPrice() {
      const reducer = (sum, v) => sum + v.marketPrice * v.quantity
      const { marketPrice, quantity } = this.commodity
      let bundledSum = this.config.bundledList.reduce(reducer, marketPrice * quantity)
      return this.config.serviceList && this.config.serviceList.reduce(reducer, bundledSum)
    },
    delPrice() {
      return this.isBundled ? this.bundledDelPrice : this.commodity.marketPrice
    },
    // 对价格的样式进行动态判断 '00' '99' 都是灰色 #333
    price() {
      // if (this.orderStatus != '01') return ['noHigh']
      // else return ['price']
      return ['noHigh']
    },
    getPackage() {
      const obj = {}
      obj.skuUnit = this.commodity
      obj.bundleUnits = this.config.bundledList
      return obj
    },
    laserInfoChange() {
      if (this.config.laserInfo || this.config.laserInfoV2) {
        return this.config.laserInfoV2 ? this.config.laserInfoV2 : this.config.laserInfo
      }
      return false
    },
    stepNumChange() {
      return this.commodity?.actTagCode == 'offlineDelivery' ? this.commodity.quantity : '1'
    }
  },
  methods: {
    onChange(applyNum) {
      let params = {
        orderNo: this.orderNo,
        orderItemNo: this.orderItemNo,
        quantity: applyNum
      }
      calcRefundCommodityReq(params).then(data => {
        this.gList = data.orderCommodityUnit.giftList
      })
      this.$emit('changApplyNum', this.orderItemNo, applyNum)
    },
    handleClick(bundledCommodity) {
      if (this.clickEvent) {
        return this.$emit('product-click')
      }
      const { type, orderNo, linkBase } = this
      if (type === 'list' || type === 'apply-list') {
        // 用 push 会存在vuex的数据无法刷新，暂时使用 href
        this.$router.push(`/my/order/detail?orderNo=${orderNo}&tempTerminal=${this.tempTerminal}`)
      } else if (type === 'detail') {
        if ((this.orderType == '12' || this.orderBase?.orderType == '12') && !env.isvChat) {
          this.$toast('内购商品不可查看')
          return
        }
        let link = ''
        if (this.grouponStatus !== 0) {
          let types = this.grouponType ? 'lottery' : 'group'
          link = `${linkBase}/product/${this.commodity.commoditySpuId}?skuId=${this.commodity.commoditySkuId}&channel=${types}`
        } else if (this.linkToProduct) {
          // 跳转到详情页 todo
          if (bundledCommodity) {
            link = `${linkBase}/product/${bundledCommodity.commoditySpuId}?skuId=${bundledCommodity.commoditySkuId}`
          } else {
            link = `${linkBase}/product/${this.commodity.commoditySpuId}?skuId=${this.commodity.commoditySkuId}`
          }
        }
        app.openNewWebview({
          url: link
        })
      }
    },
    showBigImg() {
      if (
        app.viewImgs({
          browse: {
            images: [this.laserInfoChange.previewSrc],
            imageIndex: 0
          }
        })
      ) {
        // 客户端查看大图
      } else {
        if (this.bigImgCallback) {
          this.laserInfoChange && this.bigImgCallback && this.bigImgCallback([this.laserInfoChange.previewSrc])
        } else {
          this.isShowBigImg = true
        }
      }
    },
    hideBigImg() {
      this.isShowBigImg = false
    },
    handleGiftSelect(obj) {
      this.$emit('optionGiftChange', obj)
    }
  }
})
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss" src="./fontscale.scss"></style>
